import logo from '../Assets/img/logo.png'
import logo_text from '../Assets/img/logo_text.svg'

const Logo = () => {
    return (
        <div className="flex items-center h-6 space-x-1.5">
            <img src={logo} alt="logo" className="w-auto h-8" />
            <img src={logo_text} alt="Carpool" />
        </div>
    )
}

export default Logo